import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { ObjProfilTypeCred } from "../../core/model/obj-profil-type-cred";
import { ObjProfilTypeCredService } from "../../core/service/objectif-profil-type-credit.service";

@Component({
  selector: "app-edit-objectif-profil-type-credit",
  templateUrl: "./edit-objectif-profil-type-credit.component.html",
  styleUrls: ["./edit-objectif-profil-type-credit.component.scss"],
})
export class EditObjectifProfilTypeCreditComponent implements OnInit {
  @Input() objProfilTypeCredId;

  objProfilTypeCred: ObjProfilTypeCred;
  loading = true;

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _objProfilTypeCredService: ObjProfilTypeCredService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      nbJourDossier: ["", Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getObjProfilTypeCredById(this.objProfilTypeCredId);
  }

  getObjProfilTypeCredById(objProfilTypeCredId) {
    this.loading = true;
    this._objProfilTypeCredService
      .getObjProfilTypeCredById(objProfilTypeCredId)
      .subscribe(
        (data) => {
          this.objProfilTypeCred = {
            ...data,
            typeCredit: data.typeCredit ? { ...data.typeCredit } : null,
          };
          this.loading = false;
        },
        (error) => {
          console.log(error);
          this.loading = false;
        }
      );
  }

  save(): void {
    this.pressButton = true;
    this._objProfilTypeCredService
      .putObjProfilTypeCred(this.objProfilTypeCred)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close(this.objProfilTypeCred);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
